module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ss-2ad5a2bbc138690704ada7e1a8577410.svg";